import { Expose } from "class-transformer";
import { IsString, IsNumber, IsBoolean, IsOptional } from "class-validator";

export class OfficeCashBox {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  officeId!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  currency!: string;
  @IsOptional()
  @IsString()
  @Expose()
  accountingNumber!: string | null;
  @IsBoolean()
  @Expose()
  isDeleted!: boolean;

  constructor(cashBox?: OfficeCashBox) {
    this.id = cashBox != undefined ? cashBox.id : 0;
    this.officeId = cashBox != undefined ? cashBox.officeId : "";
    this.name = cashBox != undefined ? cashBox.name : "";
    this.currency = cashBox != undefined ? cashBox.currency : "";
    this.accountingNumber = cashBox != undefined ? cashBox.accountingNumber : "";
    this.isDeleted = cashBox != undefined ? cashBox.isDeleted : false;
  }
}
